import requestWrapper from '../shared/lib/requestWrapper';
import constants from '../shared/constants';

async function create(payload) {
    var response = await requestWrapper({
        url:    '/DietaryDiagnostic',
        method: 'POST',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function update(payload) {
    var response = await requestWrapper({
        url:    '/DietaryDiagnostic/' + payload.data.id,
        method: 'PUT',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function search(payload) {
    var response = await requestWrapper({
        url:    '/DietaryDiagnostic/search/',
        method: 'POST',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

const DietaryDiagnosticService = {
    create, update, search
}

export default DietaryDiagnosticService;